import React, { useState } from 'react';
import { observer } from 'mobx-react';
import ParseHTML from 'html-react-parser';
import Tag from '../Tag';

import styles from './LotDescription.module.scss';
import { BNS3_MAX_AMOUNT_OF_LOT_TAGS } from '../../../../constants';
import { useQueryParams } from '../../../../hooks/useQueryParams';
import { useStores } from 'stores';

const LotDescription = () => {
  const {
    singleLotStore: {
      singleLot: { tags, description },
    },
    lotStore,
  } = useStores();
  const { setFilters } = lotStore;
  const [hideRedundantTags, setHideRedundantTags] = useState(true);
  const { updateQueryParams } = useQueryParams();

  const handleSaveCheckedTags = (id, name) => {
    const value = { tagId: { id, name } };
    setFilters({ tagId: value });
    updateQueryParams([{ name: 'tagId', value: id }]);
  };

  const showRedundantTagsHandler = () => {
    setHideRedundantTags(false);
  };

  const showRedundantTagsButton = (
    <button
      onClick={showRedundantTagsHandler}
      type="button"
      key="show-tags-button"
      className={styles.bns3_show_tags_button}
    >
      ...
    </button>
  );

  const renderTags = () => {
    if (!(tags && tags.length > 0)) {
      return <p className={styles.bns3_no_tags_text}>No tags provided</p>;
    }

    const tagsToRender = tags.map(({ id, name }) => (
      <Tag key={id} id={id} handleSaveCheckedTags={() => handleSaveCheckedTags(id, name)}>
        {name}
      </Tag>
    ));

    if (hideRedundantTags && tagsToRender.length > BNS3_MAX_AMOUNT_OF_LOT_TAGS) {
      tagsToRender.splice(BNS3_MAX_AMOUNT_OF_LOT_TAGS);
      tagsToRender.push(showRedundantTagsButton);
    }

    return tagsToRender;
  };

  const formattedDescription = description?.replace(/\n/g, '<br />');

  return (
    <>
      <h2 className={styles.bns3_lot_description_title}>Description</h2>
      <div className={styles.bns3_lot_description_text} data-testid="product-details">
        {description && ParseHTML(formattedDescription)}
      </div>

      {tags && tags.length > 0 ? (
        <div className={styles.bns3_tags_list}>{renderTags()}</div>
      ) : (
        <p className={styles.bns3_no_tags_text}>No tags provided</p>
      )}
    </>
  );
};

export default observer(LotDescription);
